import { viewProfile } from 'services/endpoints/profile'

const PROFILE_VIEW_PREFIX = 'profile-view'

const getProfileViewBucket = (isSubscribed: boolean): string => {
  const now = new Date()

  if (isSubscribed) {
    return [
      now.getFullYear(),
      now.getMonth() + 1,
      now.getDate(),
      now.getHours()
    ].join('-')
  }

  return [
    now.getFullYear(),
    now.getMonth() + 1,
    now.getDate()
  ].join('-')
}

export const trackProfileView = async ({
  viewerId,
  profileId,
  isSubscribed
}: {
  viewerId: string
  profileId: string
  isSubscribed: boolean
}): Promise<void> => {
  if (
    !viewerId ||
    !profileId ||
    viewerId === profileId
  ) {
    return
  }


  const bucket = getProfileViewBucket(isSubscribed)

  const storageKey = [
    PROFILE_VIEW_PREFIX,
    viewerId,
    profileId,
    isSubscribed ? 'subscribed' : 'unsubscribed',
    bucket
  ].join(':')

  try {
    if (localStorage.getItem(storageKey)) {
      return
    }

    /*
     * Mark it before sending so multiple React effects/renders
     * cannot trigger simultaneous requests.
     */
    localStorage.setItem(storageKey, 'pending')

    await viewProfile(profileId, isSubscribed)

    localStorage.setItem(storageKey, 'tracked')
  } catch (error) {
    /* 
     * Let a later navigation retry if the request actually failed.
     */
    localStorage.removeItem(storageKey)

    console.error('Failed to track profile view', error)
  }
}